import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses, mobileIs } from "../../utils/siteUtils";
import "./style.scss";
const SectionTitle = props => {
	const { lang, rendering, fields, page } = props;
  const { title } = fields;
  const isMobile = mobileIs()
  const renderingClass = 'c-section-title' + '_' + rendering.dataSource;
  const onScroll = () => {
    let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight;
    let dom = document.getElementsByClassName(renderingClass);
    if (isMobile) {
      if (dom[0].getBoundingClientRect().top < pageHeight + 100) {
        dom[0].setAttribute('animate', 'fadeIn');
      } else {
        dom[0].setAttribute('animate', 'fadeOut');
      }
    } else {
      if (dom[0].getBoundingClientRect().top < pageHeight - 50) {
        dom[0].setAttribute('animate', 'fadeIn');
      } else {
        dom[0].setAttribute('animate', 'fadeOut');
      }
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const rootClasses = classNames("c-section-title", getOverallSettingsClasses(fields));
  
	return (
    <div className={rootClasses} datasourceid={rendering.dataSource}>
    	<RichText className={classNames("c-section-title__title", renderingClass)} tag="div" field={title} />
    </div>
  );
};

export default 	SectionTitle;